import { baseApi } from "@dex/bubl-fetch";

const endpoint = 'CampCoaches';

const CampCoachesApi: any = baseApi(endpoint);

export default CampCoachesApi;